<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100">
  <path
    data-player="true"
    d="M49.997 100c-6.621 0-3.182-28.187-12.496-37.506C28.181 53.18 0 55.861 0 49.997c0-6.257 28.181-3.182 37.501-12.496C46.815 28.181 43.752 0 49.997 0c6.485 0 3.183 28.181 12.502 37.501C71.813 46.815 100 43.974 100 49.997c0 5.71-28.187 3.183-37.501 12.497C53.18 71.813 56.778 100 49.997 100Z"
    fill="#4e8074"
  />
</svg>
